import HTTP from "@/http-common";
export const state = {
  tickets: [],
  ticketSearch: {
    keyword: null,
    statusFilter: -1,
    pageSize: 50
  }
};

export const getters = {
};

export const mutations = {
};
export const actions = {
  async createNewTicket({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/SubmitTroubleTicket", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getTickets({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/GetTroubleTickets", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getTicket({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/GetTroubleTicketByTicketId", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async addTicketNote({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/AddTroubleTicketNote", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async amendTroubleTicket({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/AmendTroubleTicket", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
};
